
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add/[[...currency]]",
      function () {
        return require("private-next-pages/add/[[...currency]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add/[[...currency]]"])
      });
    }
  